module.exports = __webpack_public_path__ + "static/media/pdf.0aaca7ee.png";